module.exports = __webpack_public_path__ + "img/boys-girls-logo.6ce48d55.jpg";